import createUser from './createUser';

export default createUser;
